"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlOcppAuthorizedTransactionsValidation = void 0;
const OcppAuthorizedTransactionValidation_1 = require("./OcppAuthorizedTransactionValidation");
class ChargerControlOcppAuthorizedTransactionsValidation {
    static isValid(entity) {
        // Validate entity.authorizations for existence and correct type.
        if (entity.authorizations == undefined)
            return false;
        if (!Array.isArray(entity.authorizations))
            return false;
        if (!entity.authorizations.every((elem) => {
            if (!OcppAuthorizedTransactionValidation_1.OcppAuthorizedTransactionValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargerControlOcppAuthorizedTransactionsValidation = ChargerControlOcppAuthorizedTransactionsValidation;
